var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nissan-wechat-login"},[_c('img',{staticClass:"img-btn-wechat",attrs:{"src":require("./images/btn-wechat.png")},on:{"click":_vm.wechatLogin}})])
}
var staticRenderFns = []

export { render, staticRenderFns }